import './quote.css';

const Quote = () => (
  <div className="quote_page">
    <p className="quote">
      &quot;As far as the laws of mathematics refer to reality,
      they are not certain; and as far as they are certain, they do not refer to reality&quot;.
      -
      {' '}
      <span className="author">Albert Einstein</span>
    </p>
  </div>
);

export default Quote;
